module.exports = __webpack_public_path__ + "img/s9pro_cut.81aea1a3.png";